export default __webpack_public_path__ + "7a057787bfe71093f3f926b7990654f8.svg";